module.exports = __webpack_public_path__ + "d768141edf2a5442a5fb6c1c3b9b8b7a.pdf";